import configHelper from '@/config/ConfigHelper'

function GenerateConfig () {
  return [
    {
      label: 'Android',
      value: 0,
    },
    {
      label: 'IOS',
      value: 1,
    },
  ]
}


export function TIPOS_PLATAFORMA (state) {
  return configHelper.getConfig(state, 'TIPOS_PLATAFORMA', GenerateConfig, false)
}
